import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconAssigneeSmall(props: IconSmallProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path
        d="M8 6C8.55293 6 9 5.55293 9 5C9 4.44707 8.55293 4 8 4C7.44707 4 7 4.44707 7 5C7 5.55293 7.44707 6 8 6ZM11 5C11 6.6575 9.6575 8 8 8C6.3425 8 5 6.6575 5 5C5 3.3425 6.3425 2 8 2C9.6575 2 11 3.3425 11 5ZM3.91361 9.72628C5.27457 9.24165 6.88831 9 8 9C9.11169 9 10.7254 9.24165 12.0864 9.72628C12.7654 9.96805 13.4474 10.2931 13.9784 10.7288C14.509 11.1641 15 11.8086 15 12.6667V15H1V12.6667C1 11.8086 1.49103 11.1641 2.02164 10.7288C2.55262 10.2931 3.23463 9.96805 3.91361 9.72628ZM3.29016 12.275C3.00866 12.5059 3 12.6381 3 12.6667V13H13V12.6667C13 12.6381 12.9913 12.5059 12.7098 12.275C12.4287 12.0444 11.9862 11.8136 11.4155 11.6104C10.2771 11.205 8.89081 11 8 11C7.10919 11 5.72293 11.205 4.58452 11.6104C4.0138 11.8136 3.57129 12.0444 3.29016 12.275Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
